import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { apiFetch } from '../lib/api'

export function AuthVerify() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState('')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setError('No token provided')
      return
    }

    async function verify() {
      try {
        const data = await apiFetch('/api/auth/verify', {
          method: 'POST',
          body: JSON.stringify({ token }),
        })

        if (data.token) {
          localStorage.setItem('digsafe_token', data.token)
          navigate('/')
        } else {
          setError(data.error || 'Verification failed')
        }
      } catch (err) {
        setError('Something went wrong. Try again.')
      }
    }

    verify()
  }, [searchParams, navigate])

  if (error) {
    return (
      <div className="page login">
        <div className="login-card">
          <div className="logo">🏨</div>
          <h1>DIGSAFE</h1>
          <p className="error">{error}</p>
          <a href="/login" className="btn-primary" style={{ display: 'block', textDecoration: 'none' }}>
            Back to login
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="page login">
      <div className="login-card">
        <div className="logo">🏨</div>
        <h1>DIGSAFE</h1>
        <p className="subtitle">Logging you in...</p>
      </div>
    </div>
  )
}
